// THIS IS RESULTS COLLECTION FROM NOSTO

const baseUrl = window.location.pathname;
function getNostoStoreCurrencySymbol() {
  if (
    typeof window.theme !== "undefined" &&
    window.theme.settings &&
    window.theme.settings.storeCurrencyGlobalSetting
  ) {
    return window.theme.settings.storeCurrencyGlobalSetting;
  }
  if (typeof document !== "undefined" && document.documentElement) {
    var attr = document.documentElement.getAttribute("data-nosto-currency-symbol");
    if (attr) return attr;
  }
  return "";
}
const storeCurrencyGlobalSetting = getNostoStoreCurrencySymbol();
const accountId =
  (typeof window.theme !== 'undefined' && window.theme.settings && window.theme.settings.nostoAccountId) ||
  '';

function getNostoSearchItemsPerPage() {
  var fallback = 24;
  if (typeof window !== "undefined" && window.theme && window.theme.settings) {
    var s = window.theme.settings.nostoSearchItemsPerPage;
    if (s !== undefined && s !== null && s !== "") {
      var n = parseInt(s, 10);
      if (!isNaN(n) && n >= 1) return n;
    }
  }
  return fallback;
}
const itemsPerPage = getNostoSearchItemsPerPage();
let currentPage = 1;
let selectedFacets = getSelectedFacetsFromUrl();
let totalProducts = 0;
let isLoading = false;

function nostoSearchStr(key, fallback) {
  const s = window.theme && window.theme.strings && window.theme.strings[key];
  if (typeof s === "string" && s.length) return s;
  return fallback;
}

function nostoRoundedDiscountPerc(strikePrice, salePrice) {
  const strike = parseFloat(strikePrice);
  const sale = parseFloat(salePrice);
  if (Number.isNaN(strike) || Number.isNaN(sale) || strike <= sale) return 0;
  return Math.round(((strike - sale) / strike) * 100);
}

function nostoSearchUseRoundPrices() {
  return Boolean(
    window.theme &&
      window.theme.settings &&
      window.theme.settings.nostoRoundPrices,
  );
}

function nostoSearchPriceDecimals() {
  return nostoSearchUseRoundPrices() ? 0 : 2;
}

// Function to update URL with current page and selected facets
function updateURL(page, facets, sortOption) {
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.set("page", page);
  if (facets) {
    urlParams.set("facets", JSON.stringify(facets));
  } else {
    urlParams.delete("facets");
  }
  if (sortOption) {
    urlParams.set("sort", sortOption);
  } else {
    urlParams.delete("sort");
  }
  history.pushState(null, null, "?" + urlParams.toString());
}

// Function to get selected facets from URL
function getSelectedFacetsFromUrl() {
  const urlParams = new URLSearchParams(window.location.search);
  const facetsParam = urlParams.get("facets");
  return facetsParam ? JSON.parse(facetsParam) : [];
}

function extractSearchQueryFromUrl() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("q");
}

async function fetchProducts(page, facets, sortOption) {
  const from = (page - 1) * itemsPerPage;
  const facetsFilter = facets.length > 0 ? customStringify(facets) : "[]";
  const searchTerm = extractSearchQueryFromUrl();

  let sortBy = [];
  switch (sortOption) {
    case "price-high-to-low":
      sortBy.push({ field: "price", order: "desc" });
      break;
    case "price-low-to-high":
      sortBy.push({ field: "price", order: "asc" });
      break;
    case "new":
      sortBy.push({ field: "datePublished", order: "desc" });
      break;
    case "popularity":
    default:
      sortBy.push({ field: "popularity", order: "desc" });
      break;
  }

  async function waitForNostojs() {
    return new Promise((resolve) => {
      const interval = setInterval(() => {
        if (typeof nostojs !== "undefined") {
          clearInterval(interval);
          resolve();
        }
      }, 100);
    });
  }

  async function fetchSearchSessionParams() {
    await waitForNostojs();
    return new Promise((resolve) => {
      nostojs((api) => {
        api.getSearchSessionParams().then((response) => {
          resolve(response);
        });
      });
    });
  }

  const sessionParams = await fetchSearchSessionParams();
  const sessionParamsString = JSON.stringify(sessionParams).replace(
    /"([^"]+)":/g,
    "$1:",
  );

  const graphqlQuery = `
      query {
        search(
          accountId: "${accountId}",
          sessionParams: ${sessionParamsString},
          query: "${searchTerm}",
          products: {
            size: ${itemsPerPage},
            from: ${from},
            facets: ["*"],
            filter: ${facetsFilter},
            sort: ${customSortStringify(sortBy)}
          }
        ) {
          redirect
          products {
            hits {
              productId
              categoryIds
              name
              datePublished
              url
              imageUrl
              alternateImageUrls
              price
              listPrice
              priceCurrencyCode
              reviewCount
              tags1
              customFields {
                key
                value
              }
              skus {
                name
                price
                url
                availability
                id
                customFields{
                  key 
                  value
                }
              }
            }
            total
            size
            facets {
              ... on SearchTermsFacet {
                id
                field
                type
                name
                data {
                  value
                  count
                  selected
                }
              }
            }
          }
        }
      }
    `;

  const response = await fetch("https://search.nosto.com/v1/graphql", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ query: graphqlQuery }),
  });
  return response.json();
}

async function renderProductsAndPagination(page, facets, sortOption) {
  if (isLoading) return;
  isLoading = true;

  let allProducts = [];
  let allFacets = [];

  // Fetch products for the current page
  const data = await fetchProducts(page, facets, sortOption);
  if (data.data && data.data.search && data.data.search.products) {
    if (data.data.search.redirect) {
      window.location.href = data.data.search.redirect;
      return; // Stop further processing
    }
    const products = data.data.search.products.hits;
    totalProducts = data.data.search.products.total;
    allProducts = allProducts.concat(products);
    allFacets = data.data.search.products.facets;

    // Call recordSearch after fetching products
    nostojs((api) => {
      api.recordSearch(
        "serp", // Type of search
        {
          query: extractSearchQueryFromUrl(), // Search query
          products: {
            sort: sortOption
              ? [
                  {
                    field: sortOption.split("-")[0],
                    order: sortOption.split("-")[1],
                  },
                ]
              : [{ field: "popularity", order: "desc" }],
            filter: facets.map((facet) => ({
              field: facet.field,
              value: facet.value,
            })),
          },
        },
        {
          products: {
            hits: products.map((product) => ({ productId: product.productId })), // List of product IDs
            total: totalProducts,
            size: itemsPerPage,
            from: (page - 1) * itemsPerPage,
          },
        },
        { isKeyword: false }, // Additional options, can be adjusted based on requirements
      );
    });
  } else {
    console.log("Products data is not available in the response.");
  }

  appendProducts(allProducts);
  renderFacets(allFacets);
  updateProductCountText();
  updateProgressBar();
  hideLoadMoreButtonIfNecessary();

  attachEventListenersToButtons(); // Attach event listeners to the buttons
  if (typeof bindSkuListAddToCartButtons === "function")
    bindSkuListAddToCartButtons();
  updateSelectedFacetsDisplay(selectedFacets);

  isLoading = false;
}

// Function to append products to the existing list
function appendProducts(products) {
  const productGridContainer = document.getElementById("ProductGridContainer");
  products.forEach((product) => {
    const productElement = createProductElement(product);

    // Add event listener to track clicks on the product
    productElement.addEventListener("click", () => {
      nostojs((api) => {
        api.recordSearchClick(
          "serp", // Type of component
          { productId: product.productId, url: product.url }, // Data for clicked product
        );
      });
    });

    productGridContainer.appendChild(productElement);
  });
}

// Function to update product count text
function updateProductCountText() {
  const showingCount =
    currentPage * itemsPerPage > totalProducts
      ? totalProducts
      : currentPage * itemsPerPage;
  document.getElementById("ProductCountText").innerText =
    `Showing ${showingCount} out of ${totalProducts} products`;
}

// Function to update the progress bar
function updateProgressBar() {
  const progressPercentage =
    ((currentPage * itemsPerPage) / totalProducts) * 100;
  document.getElementById("ProgressBar").style.width = `${progressPercentage}%`;
}

// Function to hide the "Show More Products" button if necessary
function hideLoadMoreButtonIfNecessary() {
  const totalPages = Math.ceil(totalProducts / itemsPerPage);
  document.getElementById("LoadMoreButton").style.display =
    currentPage >= totalPages ? "none" : "block";
}

function attachEventListenersToFacets() {
  const facetContainers = document.querySelectorAll(".facet");
  facetContainers.forEach((container) => {
    const facetValues = container.querySelectorAll(
      ".facet-value-color, .facet-value",
    );
    facetValues.forEach((valueElement) => {
      valueElement.addEventListener("click", () => {
        valueElement.classList.toggle("selected");
        selectedFacets = collectSelectedFacets();
        updateURL(1, selectedFacets);
        currentPage = 1;
        document.getElementById("ProductGridContainer").innerHTML = ""; // Clear existing products
        renderProductsAndPagination(currentPage, selectedFacets);
      });
    });
  });
}

function attachEventListenersToButtons() {
  if (window.theme && typeof window.theme.bindWishlistButtons === "function") {
    window.theme.bindWishlistButtons();
    if (window._swat && typeof window._swat.fetch === "function") {
      window.theme.updateWishList();
    } else {
      window.SwymCallbacks = window.SwymCallbacks || [];
      window.SwymCallbacks.push(function () {
        if (window._swat && typeof window._swat.fetch === "function") {
          window.theme.updateWishList();
        }
      });
    }
  }

  document
    .querySelectorAll(".grid-product__action.add-to-cart")
    .forEach((button) => {
      button.addEventListener("click", handleAddToCartClick);
    });

  // .sku-item: bindSkuListAddToCartButtons() in quickshop.js (data-listener-added)

  // const nostoLoadedProducts = document.querySelectorAll('.product');
  //  nostoLoadedProducts.forEach(product => {
  //    const mobileAtcSizeDrawer = product.querySelector('.mobile-atc-size-drawer');
  //    const ccart = document.querySelector(".js-drawer-open-cart");
  //    if (!mobileAtcSizeDrawer) return;
  //    mobileAtcSizeDrawer.addEventListener('click', function(evt) {
  //      if (mobileAtcSizeDrawer.classList.contains('already-in-cart')) {
  //        ccart.click();
  //      }
  //      evt.stopPropagation();
  //      evt.preventDefault();
  //      // theme.SizeDrawer.open(evt, mobileAtcSizeDrawer.getAttribute('data-product-handle'));
  //    });
  //  });

  const tooltipbtns = document.querySelectorAll(".tooltip-btn");
  tooltipbtns.forEach((tooltip) => {
    tooltip.addEventListener("click", function () {
      // Find the previous sibling with the class 'tooltip-content'
      let tooltipContent = this.previousElementSibling;

      tooltipContent.addEventListener("click", function () {
        tooltipContent.classList.remove("show");
        setTimeout(() => (tooltipContent.style.display = "none"), 500);
      });

      // Toggle the 'show' class to control visibility
      if (tooltipContent.classList.contains("show")) {
        tooltipContent.classList.remove("show");
        setTimeout(() => {
          tooltipContent.style.display = "none";
          tooltipContent.style.zIndex = "-1";
        }, 500); // Ensures fade effect completes
      } else {
        tooltipContent.style.display = "flex";
        setTimeout(() => {
          tooltipContent.classList.add("show");
          tooltipContent.style.zIndex = "1";
        }, 10); // Timeout ensures smooth transition
      }
    });
  });
  // setTimeout(() => {
  //   // Select all elements with the class .nosto-product-images
  //   const nostoProductImages = document.querySelectorAll('.nosto-product-images');

  //   // Loop through each selected element and initialize Flickity
  //   nostoProductImages.forEach((element) => {
  //       new Flickity(element, {
  //           cellAlign: 'center',
  //           contain: true,
  //           draggable: true,
  //           wrapAround: true,
  //           pageDots: true,
  //           prevNextButtons: true,
  //           groupCells: 1
  //       });
  //   });
  // }, 500);
}

// Add to cart click handler
// function handleAddToCartClick(evt) {
//   const addToCart = evt.currentTarget;
//   const product = addToCart.closest('.nosto-product-info');
//   const ccart = document.querySelector(".js-drawer-open-cart");
//   if (!addToCart) return;

//   evt.stopPropagation();
//   evt.preventDefault();

//   if (addToCart.classList.contains('already-in-cart')) {
//     ccart.click();
//   }
//   // theme.SizeDrawer.open(evt, product.getAttribute('data-product-handle'));

// }

function collectSelectedFacets() {
  const selectedFacets = [];
  const facetContainers = document.querySelectorAll(".facet");
  facetContainers.forEach((container) => {
    const facetName = container.querySelector(".facet-name").textContent.trim();
    const facetValues = container.querySelectorAll(
      ".facet-value.selected, .facet-value-color.selected",
    );
    if (facetValues.length > 0) {
      const field = container.querySelector("[id]").id;
      const values = Array.from(facetValues).map((valueElement) => {
        const anchor = valueElement.querySelector("a");
        const btn = valueElement.querySelector("button");
        if (anchor) return anchor.title;
        if (btn && btn.title) return btn.title;
        return valueElement.textContent.trim();
      });
      selectedFacets.push({ field, value: values });
    }
  });
  return selectedFacets;
}

function customStringify(obj) {
  if (Array.isArray(obj)) {
    return `[${obj.map(customStringify).join(",")}]`;
  } else if (typeof obj === "object" && obj !== null) {
    const entries = Object.entries(obj).map(
      ([key, value]) => `${key}:${customStringify(value)}`,
    );
    return `{${entries.join(",")}}`;
  } else if (typeof obj === "string") {
    return `"${obj}"`;
  } else {
    return String(obj);
  }
}
function customSortStringify(sortArray) {
  return (
    "[" +
    sortArray
      .map((sortObj) => `{field: "${sortObj.field}", order: ${sortObj.order}}`)
      .join(", ") +
    "]"
  );
}

// Render Products function
function renderProducts(products) {
  const productGridContainer = document.getElementById("ProductGridContainer");
  productGridContainer.innerHTML = ""; // Clear existing products
  products.forEach((product) => {
    const productElement = createProductElement(product);
    productGridContainer.appendChild(productElement);
  });
}

// Create Product Element function
// Create Product Element function
function createProductElement(product) {
  const productElement = document.createElement("div");
  productElement.classList.add("product");
  const productTitleCustom = (product.url.split("/products/")[1] || "").split("?")[0].split("#")[0];
  productElement.dataset.productHandle = productTitleCustom;
  const pd = nostoSearchPriceDecimals();
  const formattedPrice = product.price.toFixed(pd);
  const formattedListPrice = product.listPrice.toFixed(pd);

  const customBadgeField = product.customFields.find(
    (field) => field.key === "custom-badges",
  );
  let customBadges = customBadgeField ? customBadgeField.value : "";

  let lowest30dPriceAmount = null;
  if (product.skus && product.skus.length > 0) {
    const lowest30dPriceField = product.skus[0].customFields?.find(
      (field) => field.key === "frykland_pricehistory-lowest",
    );

    if (lowest30dPriceField) {
      const lowest30dPrice = JSON.parse(lowest30dPriceField.value);
      lowest30dPriceAmount = parseFloat(lowest30dPrice.amount).toFixed(pd);
    }
  }

  const showProductPriceHistorySetting =
    typeof window !== "undefined" &&
    window.theme &&
    window.theme.settings &&
    window.theme.settings.showProductPriceHistory;
  const omnibusLowestShown = showProductPriceHistorySetting
    ? lowest30dPriceAmount
    : null;

  if (product.listPrice > product.price) {
    const saleBadgeGids =
      typeof window !== "undefined" &&
      window.theme &&
      window.theme.settings &&
      Array.isArray(window.theme.settings.nostoSaleBadgeMetaobjectGids)
        ? window.theme.settings.nostoSaleBadgeMetaobjectGids.filter(Boolean)
        : [];
    if (saleBadgeGids.length) {
      customBadges = customBadges ? JSON.parse(customBadges) : [];
      customBadges = customBadges.concat(saleBadgeGids);
    }
  }

  if (Array.isArray(customBadges)) {
    customBadges = JSON.stringify(customBadges);
  }

  // Check for exclude_ tags
  const excludeTags = Array.isArray(product.tags1)
    ? product.tags1
        .filter((tag) => tag.startsWith("exclude_"))
        .map((tag) => tag.replace("exclude_", ""))
    : [];

  const hasBundleTag =
    Array.isArray(product.tags1) && product.tags1.includes("bundle");

  const wcategories = product?.categoryIds || [];
  const discountBoxes = document.querySelector(
    ".logged-in-discounts-box-overview-page",
  );

  let bestDiscount = null;

  if (Array.isArray(wcategories) && discountBoxes) {
    let i = 1;

    while (true) {
      const idsSpan = discountBoxes.querySelector(`.discount-ids-${i}`);
      const percentageSpan = discountBoxes.querySelector(
        `.discount-percentage-${i}`,
      );
      const titleSpan = discountBoxes.querySelector(`.discount-title-${i}`);

      if (!idsSpan || !percentageSpan || !titleSpan) break; // no more groups

      const discountIds = idsSpan.innerText.split(",").map((id) => id.trim());
      const matchFound = wcategories.some((catId) =>
        discountIds.includes(String(catId)),
      );

      if (matchFound) {
        const percentage = parseFloat(percentageSpan.innerText.trim());
        if (!bestDiscount || percentage > bestDiscount.percentage) {
          bestDiscount = {
            discountIdGroup: i,
            percentage,
            title: titleSpan.innerText.trim(),
            ids: discountIds,
          };
        }
      }

      i++;
    }
  }

  if (bestDiscount) {
    console.log("Best Discount Found:", bestDiscount);
    // Use: bestDiscount.percentage, bestDiscount.title, etc.
  }

  const discountHTML = bestDiscount
    ? `<div class="nosto-discount-banner"> ${bestDiscount.title} </div>`
    : "";

  const discountPercentage = bestDiscount?.percentage ?? 0;
  const discountedPriceLoggedIn = (product.price * discountPercentage) / 100;
  const newPriceLoggedInF = product.price - discountedPriceLoggedIn;
  const newPriceLoggedIn = newPriceLoggedInF.toFixed(pd);
  const isOnSale = product.listPrice > product.price;
  const hasMemberDiscount = Boolean(discountHTML);

  const reviewsRatingField = product.customFields.find(
    (field) => field.key === "reviews-rating",
  );
  const reviewsRatingRaw = reviewsRatingField
    ? JSON.parse(reviewsRatingField.value).value
    : null;
  const reviewsRating =
    reviewsRatingRaw == null
      ? null
      : String(reviewsRatingRaw).split("(")[0].trim() || null;

  const reviewsRatingCountField = product.customFields.find(
    (field) => field.key === "reviews-rating_count",
  );
  const reviewsRatingCount = reviewsRatingCountField
    ? reviewsRatingCountField.value
    : 0;
  const reviewsRatingCountSuffix =
    Number(reviewsRatingCount) > 0 ? ` (${reviewsRatingCount})` : "";

  const productColorVariantsField = product.customFields.find(
    (field) => field.key === "product-color_variants",
  );
  const productColorVariants = productColorVariantsField
    ? productColorVariantsField.value
    : "";
  const productColorVariantsCount = productColorVariants
    ? productColorVariants.split("|").length - 1
    : 0;

  const alternateImageUrls = product.alternateImageUrls
    ? product.alternateImageUrls.slice(0, 7)
    : [];
  const pricedif =
    omnibusLowestShown != null
      ? omnibusLowestShown - product.price
      : NaN;
  let discountPercentageC = "";
  if (omnibusLowestShown == null) {
    const perc = nostoRoundedDiscountPerc(product.listPrice, product.price);
    if (perc > 0) discountPercentageC = `-${perc}%`;
  } else if (pricedif > 1 && omnibusLowestShown > product.price) {
    const perc = nostoRoundedDiscountPerc(omnibusLowestShown, product.price);
    if (perc > 0) discountPercentageC = `-${perc}%`;
  }
  const nostoUi = {
    wishlistAdd: nostoSearchStr("nostoSearchWishlistAdd", "Add to wishlist"),
    wishlistRemove: nostoSearchStr("nostoSearchWishlistRemove", "Remove from wishlist"),
    priceTooltip: nostoSearchStr(
      "nostoSearchPriceHistoryTooltip",
      (typeof window !== "undefined" &&
        window.themeStrings &&
        window.themeStrings.price_note) ||
        "",
    ),
    mobileAddAria: nostoSearchStr("nostoSearchMobileAddAria", "Add to cart"),
    skuAddToCart: nostoSearchStr("nostoSearchSkuAddToCart", "Add to cart"),
    colorsMore:
      window.theme &&
      window.theme.strings &&
      window.theme.strings.colorsMore
        ? String(window.theme.strings.colorsMore).replace(
            "[count]",
            String(productColorVariantsCount),
          )
        : "Colors +" + productColorVariantsCount,
  };

  let priceContainerInnerHtml = "";
  if (hasMemberDiscount) {
    priceContainerInnerHtml = `
      <span class="search-result__price money grid-product__price price discounted-price-custom">${newPriceLoggedIn} ${storeCurrencyGlobalSetting}</span>
      <span class="search-result__price money grid-product__price price-compare-nosto product__price--compare">${formattedPrice} ${storeCurrencyGlobalSetting}</span>
      ${discountHTML}`;
  } else if (isOnSale) {
    priceContainerInnerHtml = `
      <span class="search-result__price money grid-product__price price discounted-price-custom">${formattedPrice} ${storeCurrencyGlobalSetting}</span>
      <span class="search-result__price money grid-product__price price-compare-nosto product__price--compare" style="${omnibusLowestShown < 1 ? "" : "display:none;"}">${formattedListPrice} ${storeCurrencyGlobalSetting}</span>
      <span class="search-result__price money grid-product__price price-compare-nosto app-price product__price--compare" style="${omnibusLowestShown !== null && pricedif > 1 && omnibusLowestShown > product.price ? "" : "display:none;"}">${omnibusLowestShown} ${storeCurrencyGlobalSetting}</span>
      <div class="custom-tooltip-notice" style="${omnibusLowestShown !== null && pricedif > 1 && omnibusLowestShown >= product.price && omnibusLowestShown !== formattedListPrice ? "display:flex;" : "display:none;"}">
        <span class="sale-perc"></span>
        <div class="tooltip-content">
          <p>${nostoUi.priceTooltip}</p>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x-circle"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-info tooltip-btn" style="width: 15px;margin-right:5px;"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
      </div>
      <span class="sale-perc-s-h" style="${discountPercentageC ? "" : "display:none;"}">${discountPercentageC}</span>`;
  } else {
    priceContainerInnerHtml = `<span class="search-result__price money grid-product__price price">${formattedPrice} ${storeCurrencyGlobalSetting}</span>`;
  }

  productElement.innerHTML = `
    <div class="search-result nosto-product-info product-bundle-${hasBundleTag}" data-product-handle="${productTitleCustom}" data-variant-id="${product.skus && product.skus[0] ? product.skus[0].id : ""}" data-product-url="${product.url}" data-product-id="${product.productId}" data-product-image-url="${product.imageUrl}">
      <div class="top-container">
        <a href="${product.url}">
          <div class="nosto-product-images">
          <img src="${product.imageUrl}" alt="${product.name}" class="nosto-product-image">
          ${alternateImageUrls
            .map(
              (url) => `
            <style>
              .nosto-product-info[data-product-id="${product.productId}"] .nosto-product-images::after {
                content: "";
                background-image: url('${url}');
              }
            </style>
          `,
            )
            .join("")}
        </div>
        </a>
          <div class="badges"></div>
          <p class="hide replace-badges">${customBadges}</p>
      
        <div class="wishlist-new-pdp">
          <button class="grid-product__action wishlist flip-animation" type="button" data-button-action="wishlist" data-empi="${product.productId}" data-with-epi="true" data-product-handle="${productTitleCustom}" data-product-id="${product.productId}" data-variant-id="${product.skus && product.skus[0] ? product.skus[0].id : ""}" data-product-image-url="${product.imageUrl}" data-product-url="${product.url}">
            <div class="front-side">
              <svg aria-hidden="true" focusable="false" role="presentation" class="header-icon" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26.724 23.5">
                <g id="Icon_-_Heart" transform="translate(0.75 0.75)">
                  <path id="Path" d="M24.569,4.444a6.638,6.638,0,0,0-9.389,0L13.9,5.722,12.623,4.444a6.638,6.638,0,0,0-9.389,9.387l1.28,1.279L13.9,24.5l9.387-9.389,1.28-1.279A6.636,6.636,0,0,0,24.569,4.444Z" transform="translate(-1.29 -2.499)" fill="none" stroke="#222" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                </g>
              </svg>
                   <span class="icon__fallback-text">${nostoUi.wishlistAdd}</span>
            </div>
            <div class="back-side" aria-hidden="true">
              <svg aria-hidden="true" focusable="false" role="presentation" class="header-icon" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26.724 23.5">
                <g id="Icon_-_Heart" transform="translate(0.75 0.75)">
                  <path id="Path" d="M24.569,4.444a6.638,6.638,0,0,0-9.389,0L13.9,5.722,12.623,4.444a6.638,6.638,0,0,0-9.389,9.387l1.28,1.279L13.9,24.5l9.387-9.389,1.28-1.279A6.636,6.636,0,0,0,24.569,4.444Z" transform="translate(-1.29 -2.499)" fill="#fff" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
                </g>
              </svg>
              <span class="icon__fallback-text">${nostoUi.wishlistRemove}</span>
            </div>
          </button>
        </div>
      </div>
      <div class="bottom-container">
        <a class="pdp-name-bottom-container" href="${product.url}">
          <span class="search-result__name">${product.name}</span>
        </a>
        <div class="nosto-bottom-bar">
          <a href="${product.url}">
           <div class="price-container-nosto-api ${hasMemberDiscount ? " price-container-nosto-api-logged-in-discounts " : ""}">
            ${priceContainerInnerHtml}
          </div>
          </a>

         
          <div data-product-handle="${productTitleCustom}" class="mobile-atc-size-drawer" aria-label="${nostoUi.mobileAddAria}">
          <span>+</span>
          </div>
         
          

        </div>
        <div class="product-extra-data"> 
          <a href="${product.url}" style="${productColorVariantsCount > 0 ? "" : "display:none;"} ">
            <span> ${nostoUi.colorsMore}
            </span>
          </a>
          <a href="${product.url}">
            <span style=" ${reviewsRating == null ? "display:none;" : ""}"> ★ ${reviewsRating}${reviewsRatingCountSuffix}  </span>
          </a>
        </div>
        
        <div class="sku-container-new">
          <span class="sku-new-add-to-cart-sign">${nostoUi.skuAddToCart} </span>
          <div class="sku-list-new">
            ${
              product.skus && product.skus.length > 0
                ? product.skus
                    .filter((sku) => sku.price > 0) // Only include SKUs with price > 0
                    .map(
                      (sku) => `
                      <div data-variant-id="${sku.id}" class="sku-item ${sku.availability === "OutOfStock" ? "unavailable" : ""}">
                        <span class="sku-name">${sku.name}</span>
                      </div>
                    `,
                    )
                    .join("") ||
                  '<div class="no-skus">No variants available</div>'
                : '<div class="no-skus">No variants available</div>'
            }
          </div>
        </div>
        
      </div>
    </div>
  `;

  // Pass excludeTags to renderBadges
  renderBadges(productElement, product, excludeTags);
  return productElement;
}

// Render Facets function
function renderFacets(facets) {
  const facetsContainer = document.getElementById("FacetsContainer");
  facetsContainer.innerHTML = ""; // Clear existing facets
  const filtersElement = document.createElement("div");
  const closeBtn = document.createElement("div");
  closeBtn.classList.add("close-button-facets");
  closeBtn.addEventListener("click", function () {
    facetsContainer.classList.remove("active");
  });
  filtersElement.classList.add("filters");
  filtersElement.innerHTML = "Filters";
  facetsContainer.appendChild(filtersElement);
  facetsContainer.appendChild(closeBtn);

  facets.forEach((facet) => {
    if (facet && Array.isArray(facet.data)) {
      const facetElement = createFacetElement(facet);
      facetsContainer.appendChild(facetElement);
    }
  });

  attachEventListenersToFacets();
  showFacets();
  attachFacetAccordionControls();
}

// Create Facet Element function
function createFacetElement(facet) {
  const facetElement = document.createElement("div");
  facetElement.classList.add("facet");
  const facetColor = nostoSearchStr("nostoSearchFacetColor", "Color");
  const facetSize = nostoSearchStr("nostoSearchFacetSize", "Size");

  if (facet.name === facetColor) {
    facetElement.innerHTML = `                  
      <div class="${facet.name} Color" id="${facet.field}">
          <div class="facet-name">${facet.name}</div>
          <div class="facet-color-container">
            <div class="facet-values" aria-label="${facet.name}">
              ${facet.data
                .map(
                  (value) => `
              <div class="facet-color-container">
                <div class="facet-value-color ${value.selected ? "selected" : ""}">
                  <button class="${value.value}" type="button" title="${value.value}"></button>
                  <svg width="12" height="12" class="selected-color" xmlns="http://www.w3.org/2000/svg"><path d="M4.248 8.188L10.422 2l.826.826-7 7L1 6.578l.812-.826z" fill="currentColor" fill-rule="evenodd"></path></svg>
                  <span class="facet-color-name" aria-label="${value.value}">${value.value}</span>
                </div>
              </div>
            `,
                )
                .join("")}
            </div>
        </div> 
      </div>
      `;
  } else if (facet.name === facetSize) {
    const sizeOrder = [
      "XXS",
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "XXL",
      "XXXL",
      34,
      36,
      "36-38",
      37,
      38,
      39,
      "39-41",
      40,
      41,
      42,
      44,
      "86/92",
      "98/104",
      "110/116",
      "122/128",
      "134/140",
      "146/152",
      "XS/S",
      "M/L",
      "XL/XXL",
      "M",
      "M/L",
      "L",
      "XL",
      "XXL",
      "XXXL",
      "One Size",
      "Onesize",
      "XL/XXL",
    ];
    facet.data.sort((a, b) => {
      const indexA = sizeOrder.indexOf(a.value);
      const indexB = sizeOrder.indexOf(b.value);

      if (indexA === -1) return 1;
      if (indexB === -1) return -1;

      return indexA - indexB;
    });

    facetElement.innerHTML = `                  
      <div class="${facet.name}" id="${facet.field}">
        <div class="facet-name">${facet.name}</div>
        <div class="facet-values">
          ${facet.data
            .map(
              (value) => `
            <div data-color="${value.value}" class="facet-value ${value.selected ? "selected" : ""}">
              ${value.value}
            </div>
          `,
            )
            .join("")}
        </div>
      </div>
    `;
  } else {
    facetElement.innerHTML = `                  
      <div class="${facet.name}" id="${facet.field}">
        <div class="facet-name">${facet.name}</div>
        <div class="facet-values">
          ${facet.data
            .map(
              (value) => `
            <div data-color="${value.value}" class="facet-value ${value.selected ? "selected" : ""}">
              ${value.value}
            </div>
          `,
            )
            .join("")}
        </div>
      </div>
      `;
  }

  return facetElement;
}

// Render Badges function
function renderBadges(productElement, product, excludeTags) {
  const badgesContainer = productElement.querySelector(".replace-badges");
  if (badgesContainer && badgesContainer.innerHTML.trim() !== "") {
    const badgesDiv = badgesContainer.previousElementSibling;
    if (badgesDiv) {
      const content = badgesContainer.textContent.trim();
      try {
        const parsedContent = JSON.parse(content);
        const storeBadges = document.querySelectorAll(".store-badges .badge");
        const badgeMap = {};
        storeBadges.forEach((badge) => {
          const badgeId = badge.getAttribute("data-badge-id");
          badgeMap[badgeId] = badge.outerHTML;
        });

        parsedContent.forEach((id) => {
          let newContent = badgeMap[id] || id;
          const newElement = document.createElement("div");
          const productContainer = badgesDiv.closest(".product");
          const percDiv = productContainer
            ? productContainer.querySelector(".bottom-container .sale-perc")
            : null;
          const badgePriceDecimals = nostoSearchPriceDecimals();

          let lowest30dPriceAmount = null;

          if (product.skus && product.skus.length > 0) {
            const lowest30dPriceField = product.skus[0].customFields?.find(
              (field) => field.key === "frykland_pricehistory-lowest",
            );

            if (lowest30dPriceField) {
              const lowest30dPrice = JSON.parse(lowest30dPriceField.value);
              lowest30dPriceAmount = parseFloat(lowest30dPrice.amount).toFixed(
                badgePriceDecimals,
              );
            }
          }

          if (
            !(
              typeof window !== "undefined" &&
              window.theme &&
              window.theme.settings &&
              window.theme.settings.showProductPriceHistory
            )
          ) {
            lowest30dPriceAmount = null;
          }

          const showProductPriceHistoryForBadge =
            typeof window !== "undefined" &&
            window.theme &&
            window.theme.settings &&
            window.theme.settings.showProductPriceHistory;

          const lowest30dParsed =
            lowest30dPriceAmount != null &&
            lowest30dPriceAmount !== "" &&
            String(lowest30dPriceAmount) !== "0"
              ? parseFloat(lowest30dPriceAmount)
              : null;
          const salePriceNum = Number(product.price);
          const listPriceNum = Number(product.listPrice);

          const strikeBaseForBadgePerc =
            showProductPriceHistoryForBadge &&
            lowest30dParsed != null &&
            !Number.isNaN(lowest30dParsed) &&
            lowest30dParsed > salePriceNum
              ? lowest30dParsed
              : listPriceNum > salePriceNum && !Number.isNaN(listPriceNum)
                ? listPriceNum
                : null;

          if (newContent.includes("% Sale auto")) {
            if (
              strikeBaseForBadgePerc != null &&
              strikeBaseForBadgePerc > salePriceNum &&
              strikeBaseForBadgePerc !== 0
            ) {
              const perc = nostoRoundedDiscountPerc(
                strikeBaseForBadgePerc,
                salePriceNum,
              );
              if (perc <= 0) {
                newElement.style.display = "none";
              } else {
                newContent = newContent.replace(
                  "% Sale auto",
                  `-${perc}%`,
                );
                if (percDiv) percDiv.innerHTML = newContent;
                newElement.classList.add("hide");
              }
            } else {
              newElement.style.display = "none";
            }
          }

          newElement.innerHTML = newContent;

          // Extract the numeric part of the id and check if it's in excludeTags
          const badgeIdNumericPart = id.split("/").pop();
          if (excludeTags.includes(badgeIdNumericPart)) {
            newElement.style.display = "none";
          }

          badgesDiv.appendChild(newElement);

          // Apply the z-index logic for each group of badges separately
          const badges = badgesDiv.querySelectorAll(".badge");
          const badgeGroups = {};

          // Group badges by their class (e.g., q-1-p-1, q-1-p-2, etc.)
          badges.forEach((badge) => {
            // Extract the badge's specific group class
            const groupClass = Array.from(badge.classList).find((cls) =>
              cls.match(/^q-\d+-p-\d+$/),
            );

            if (groupClass) {
              if (!badgeGroups[groupClass]) {
                badgeGroups[groupClass] = [];
              }
              badgeGroups[groupClass].push(badge);
            }
          });

          // Process each group separately
          Object.keys(badgeGroups).forEach((groupClass) => {
            const groupBadges = badgeGroups[groupClass];
            let maxZIndex = -Infinity;
            let topBadge = null;

            // Find the badge with the highest z-index in the group, excluding those in .hide divs
            groupBadges.forEach((badge) => {
              if (!badge.closest(".hide")) {
                const zIndex = parseInt(badge.style.zIndex, 10) || 0;
                if (zIndex > maxZIndex) {
                  maxZIndex = zIndex;
                  topBadge = badge;
                }
              }
            });

            // Set opacity of all badges in the group to 0 except the top one
            groupBadges.forEach((badge) => {
              if (!badge.closest(".hide") && badge !== topBadge) {
                badge.style.opacity = "0";
              } else {
                badge.style.opacity = "1"; // Ensure the top badge is visible
              }
            });
          });
        });
      } catch (e) {
        console.error("Failed to parse content as JSON:", content);
      }
    }
  }
}

const sarrowSVG = `<svg width="14" height="14" xmlns="http://www.w3.org/2000/svg"><path d="M10.056 9.944L7 6.872 3.944 9.944 3 9l4-4 4 4z" fill="currentColor" fill-rule="evenodd"></path></svg>`;

/** Accordion arrow + expand/collapse — must run after facet markup exists (each render rebuilds nodes). */
function attachFacetAccordionControls() {
  document.querySelectorAll(".facet").forEach((facet) => {
    const showfacetValues = facet.querySelector(".facet-values");
    const facetName = facet.querySelector(".facet-name");
    if (!showfacetValues || !facetName) return;

    facetName.insertAdjacentHTML("beforeend", sarrowSVG);
    facetName.addEventListener("click", () => {
      const isHidden =
        showfacetValues.style.display === "none" ||
        !showfacetValues.style.display;
      showfacetValues.style.display = isHidden ? "flex" : "none";
      facetName.classList.toggle("toggled", !isHidden);
    });
  });
}

function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

function updateSelectedFacetsDisplay(selectedFacets) {
  const filtersDiv = document.querySelector(".filters");
  if (!filtersDiv) return; // Safeguard to ensure the filtersDiv is present

  let selectedFacetsDiv = filtersDiv.querySelector(".selected-facets");
  if (!selectedFacetsDiv) {
    selectedFacetsDiv = document.createElement("div");
    selectedFacetsDiv.classList.add("selected-facets");
    filtersDiv.appendChild(selectedFacetsDiv);
  }
  selectedFacetsDiv.innerHTML = ""; // Clear previous facets

  selectedFacets.forEach((facet) => {
    facet.value.forEach((value) => {
      const facetValue = document.createElement("span");
      facetValue.classList.add("facet-value-item");
      facetValue.textContent = value;
      const closeSvg =
        '<svg width="15" class="close-facet" height="15" xmlns="http://www.w3.org/2000/svg"><path d="M11.865 4.27l-3.48 3.48 3.48 3.48-.885.885-3.48-3.48-3.48 3.48-.885-.885 3.48-3.48-3.48-3.48.885-.885 3.48 3.48 3.48-3.48z" fill="currentColor" fill-rule="evenodd"></path></svg>';
      facetValue.insertAdjacentHTML("beforeend", closeSvg);
      selectedFacetsDiv.appendChild(facetValue);
    });
  });

  attachEventListenersToCloseFacets(); // Ensure this function is defined to handle click on close icons
}

function attachEventListenersToCloseFacets() {
  document.querySelectorAll(".close-facet").forEach((closeIcon) => {
    closeIcon.addEventListener("click", function (event) {
      const facetValueItem = event.target.closest(".facet-value-item");
      const valueToRemove = facetValueItem.textContent.trim(); // Get the text content of the facet to remove

      // Update selectedFacets by removing only the clicked value
      selectedFacets = selectedFacets
        .map((facetGroup) => ({
          field: facetGroup.field,
          value: facetGroup.value.filter((value) => value !== valueToRemove), // Remove the value from the array
        }))
        .filter((facetGroup) => facetGroup.value.length > 0); // Remove any facet groups that are now empty

      updateURL(currentPage, selectedFacets);
      renderProductsAndPagination(currentPage, selectedFacets);
      updateSelectedFacetsDisplay(selectedFacets); // Refresh display
      facetValueItem.remove(); // Remove the facet display item
    });
  });
}

function showFacets() {
  const maxVisible = 9;
  const facetContainers = document.querySelectorAll(".facet-values");
  facetContainers.forEach((container) => {
    const facetValues = container.querySelectorAll(
      ".facet-color-container, .facet-value",
    );
    const moreLessButton = document.createElement("button");
    moreLessButton.classList.add("more-less-button");
    container.appendChild(moreLessButton);

    if (facetValues.length > maxVisible) {
      for (let i = maxVisible; i < facetValues.length; i++) {
        facetValues[i].classList.add("hidden");
      }

      moreLessButton.textContent = "+ More";
      moreLessButton.addEventListener("click", () => {
        const isHidden = facetValues[maxVisible].classList.contains("hidden");
        if (isHidden) {
          facetValues.forEach((item) => item.classList.remove("hidden"));
          moreLessButton.textContent = "- Less";
        } else {
          for (let i = maxVisible; i < facetValues.length; i++) {
            facetValues[i].classList.add("hidden");
          }
          moreLessButton.textContent = "+ More";
        }
      });
    } else {
      moreLessButton.style.display = "none";
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const facetsButton = document.querySelector(".facets-button");
  const facetsContainer = document.getElementById("FacetsContainer");

  facetsButton.addEventListener("click", function () {
    facetsContainer.classList.toggle("active");
  });

  document.addEventListener("click", function (event) {
    if (
      !facetsContainer.contains(event.target) &&
      !facetsButton.contains(event.target)
    ) {
      facetsContainer.classList.remove("active");
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);
  const page = parseInt(urlParams.get("page")) || 1;
  const sortOption = urlParams.get("sort") || "popularity";
  currentPage = page;
  selectedFacets = getSelectedFacetsFromUrl();
  renderProductsAndPagination(page, selectedFacets, sortOption);

  // Load more products on button click
  document
    .getElementById("LoadMoreButton")
    .addEventListener("click", function () {
      currentPage++;
      updateURL(currentPage, selectedFacets, sortOption);

      renderProductsAndPagination(currentPage, selectedFacets, sortOption);
    });

  // Facet selection event listener
  attachEventListenersToFacets();

  // Sort options event listener
  document
    .getElementById("sort-options")
    .addEventListener("change", function () {
      const newSortOption = this.value;
      updateURL(1, selectedFacets, newSortOption);
      currentPage = 1;
      document.getElementById("ProductGridContainer").innerHTML = ""; // Clear existing products
      renderProductsAndPagination(currentPage, selectedFacets, newSortOption);
      updateSelectedFacetsDisplay(selectedFacets);
    });
});
